(function () {
    "use strict";

    // @ngInject
    function CompanySettingsMobileControllerCtor($scope, $injector, UsersManager, FeaturesService) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'CompanySettingsMobileController';

        this.user = UsersManager.getCurrUser();
        this.showClientPortal = this.user.shouldShowClientPortal();
    }

    Controllers.CompanySettingsMobileController = Class(Controllers.BaseController, {
        constructor: CompanySettingsMobileControllerCtor,
    });
}());
